import { topicCategories } from "@/mocks/news";

export default function TopicSection() {
  return (
    <section id="topics" className="w-full bg-background-50 py-12 md:py-16">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-8">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 text-xs font-medium tracking-wide text-accent-700">
            <i className="ri-layout-grid-line" aria-hidden />
            主题分类
          </span>
          <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            按方向长期跟踪，比零散刷更省力
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            每个分类下都保留从首发到补充的完整记录，数字表示该方向上已经收录的线索条数。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {topicCategories.map((topic) => (
            <a
              key={topic.name}
              href="#latest"
              className="group flex items-start gap-4 rounded-lg border border-background-200 bg-background-100 p-5 transition-colors hover:border-accent-300 hover:bg-accent-50"
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-accent-500 text-background-50">
                <i className={`${topic.icon} text-xl`} aria-hidden />
              </span>
              <span className="min-w-0 flex-1">
                <span className="flex items-center justify-between gap-2">
                  <span className="font-heading text-base font-bold text-foreground-950">
                    {topic.name}
                  </span>
                  <span className="shrink-0 text-xs text-accent-700">{topic.count} 条</span>
                </span>
                <span className="mt-1.5 block text-sm leading-relaxed text-foreground-600">
                  {topic.desc}
                </span>
                <span className="mt-3 inline-flex items-center gap-1 text-xs text-foreground-500 transition-colors group-hover:text-accent-700">
                  进入该方向
                  <i className="ri-arrow-right-line" aria-hidden />
                </span>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}